// A photo as a taped Polaroid, the request as its handwritten caption.
import type { CSSProperties } from 'react';
import { Tape } from './Tape';
import { cx } from './cx';

export interface PolaroidProps {
  src: string;
  alt: string;
  caption: string;
  /** What tapes it down: the project id. */
  seed: string | number;
  /** Degrees; a little either way keeps a board from looking printed. */
  tilt?: number;
  /** 4:3 instead of square. */
  wide?: boolean;
  width?: number | string;
  className?: string;
}

export function Polaroid({ src, alt, caption, seed, tilt = -2, wide, width, className }: PolaroidProps) {
  return (
    <figure className={cx('polaroid', wide && 'wide', className)} style={{ '--tilt': `${tilt}deg`, width } as CSSProperties}>
      <img src={src} alt={alt} />
      <figcaption className="polaroid-cap">{caption}</figcaption>
      <Tape seed={seed} />
    </figure>
  );
}
